// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BiWA3","selected":"styles_selected__3vMYV"};